import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import MuiCard from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { SectionHeader } from './page.js';
/**
 * A card frames a thing a user acts on (§1.2) — a record, a KPI strip, a table. Sections
 * inside a page are separated by hairlines and spacing, not nested cards. `title` renders
 * the card title (14/600) with an optional right-hand action; `flush` drops the padding
 * for content that carries its own (a table).
 */
export function Card({ title, meta, action, flush = false, children, headingLevel = 'h2', ...rest }) {
    const header = title ? (_jsx(SectionHeader, { title: title, meta: meta, action: action, component: headingLevel })) : null;
    if (flush) {
        return (_jsxs(MuiCard, { ...rest, children: [header && _jsx(Box, { sx: { px: 2.5, pt: 2, '& > *': { mb: 0 } }, children: header }), children] }));
    }
    return (_jsx(MuiCard, { ...rest, children: _jsxs(CardContent, { children: [header, children] }) }));
}
//# sourceMappingURL=card.js.map